import React from 'react';

const CookiePolicy: React.FC = () => {
  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', fontSize: '0.95rem', color: '#333' }}>
      <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem' }}>Cookie Policy</h1>

      <h2 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>1. What are Cookies?</h2>
      <p>
        Cookies are small data files placed on your device to enhance user experience and website functionality.
      </p>

      <h2 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>2. Types of Cookies Used by Mineralex Group</h2>
      <ul>
        <li><strong>Essential Cookies:</strong> Necessary for website functionality.</li>
        <li><strong>Performance Cookies:</strong> Monitor website performance and improve user experience.</li>
        <li><strong>Functionality Cookies:</strong> Remember user preferences.</li>
        <li><strong>Analytics Cookies:</strong> Analyze user interaction.</li>
        <li><strong>Advertising Cookies:</strong> Deliver targeted advertisements.</li>
      </ul>

      <h2 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>3. Examples of Cookies Used</h2>
      <ul>
        <li><strong>Google Analytics:</strong> Tracks website usage and visitor behavior.</li>
        <li><strong>Facebook Pixel:</strong> Targets and measures effectiveness of Facebook advertisements.</li>
      </ul>

      <h2 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>4. Managing Cookies</h2>
      <p>
        Users can manage cookie settings through their browser settings or opt-out through specific platforms.
      </p>

      <h2 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>5. Third-party Cookies</h2>
      <p>
        Third-party cookies are placed by external providers to deliver additional services, including analytics and advertising.
      </p>

      <h2 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>Changes to this Cookie Policy</h2>
      <p>
        Mineralex Group may update this policy periodically. Users will be notified via website announcements or email. Continued
        website use after changes implies acceptance.
      </p>
    </div>
  );
};

export default CookiePolicy;
